export const bankReconciliationEs = {
  reconciled: `Conciliado`,
  unreconciled: `No conciliado`,
  all_transactions_with_value: `Todas las transacciones ({{count}})`,
  reconciled_transactions_with_value: `Conciliadas ({{count}})`,
  unreconciled_transactions_with_value: `No conciliadas ({{count}})`,
  reconciliation_source: `Fuente de conciliación`,
  source_type: `Tipo de fuente`,
  select_records_to_match: `Seleccionar registros para conciliar`,
  select_records_to_match_transaction_amount_of: `Seleccionar registros para conciliar el monto de la transacción de`,
  total_amount_of_reconciled_amount: `{{selectedReconcileAmount}} de {{totalReconcileAmount}}`,
  reconcile_transaction: `Conciliar transacción`,
  confirm_reconcile: `¿Está seguro de que desea conciliar esta transacción?`,
  reconcile: `Conciliado`,
  bank_transaction_reconciled_successfully: `Transacción bancaria conciliada exitosamente`,
  transacted_on: `Transacción realizada el`,
  unlink_transaction: `Desvincular transacción`,
  view_reconciled_details: "Ver detalles conciliados",
  unlink: `Desvincular`,
  starting_balance: `Saldo inicial`,
  closing_balance: `Saldo final`,
  total_credit: `Crédito total`,
  total_debit: `Débito total`,
  initial: `Inicial`,
  increased: `Aumentado`,
  decreased: `Disminuido`,
  transaction_summary: `Resumen de la transacción`,
  invoice_summary: `Resumen de la factura`,
  credit_invoices: `Facturas de crédito`,
  outstanding: `Pendiente`,
  debit_invoices: `Facturas de débito`,
  organization_payment_gateway_id_is_not_selected: `Seleccione el banco y vuelva a intentarlo`,
  reconciled_status: `Estado conciliado`,
  payment_gateway: `Pasarela de pago`,
  to_reconcile: `Por conciliar`,
  transaction_reference: ` Referencia de la transacción`,
  date_range: `Rango de fechas`,
  reconciliation_candidates: `Candidatos de conciliación`,
  no_candidates_found: `No se encontraron candidatos`,
  no_transaction_to_reconcile: `No hay transacción para conciliar`,
  select_transaction_to_reconcile: `Seleccione una transacción para ver los candidatos de conciliación`,
  reconcile_transactions: `Conciliar transacciones`,
  SaleInvoice: `Factura de venta`,
  PurchaseInvoice: `Factura de compra`,
  PaymentDebit: `Débito de pago`,
  PaymentCredit: `Crédito de pago`,
  selected_documents: `Documentos seleccionados`,
  left_to_reconcile: `Pendiente por conciliar`,
  selected_candidates_amount_should_be_equal_or_greater_than_reconcilable_amount: `El importe de los candidatos seleccionados debe ser igual o mayor que el importe conciliable`,
  selected_candidates: `Candidatos seleccionados`,
  reconcile_transaction_details: `Detalles de la transacción conciliada`,
  pagos_conciliados: `Pagos conciliados`,
  importe_combinado: `Importe combinado`,
  banktransaciton_unconcilled: `Transacción bancaria no conciliada`,
  beneficiary_id: `Identificación del beneficiario`,
  remaining: `Resto`,
  partial_reconciled: `Parcialmente reconciliado`,
  bank_transaction_unlinked_successfully: `Transacción bancaria desvinculada correctamente`,
  partial: `Parcial`,
};
